<template>
    <div
        class="rounded-32 py-2 px-8"
        :class="badgeClass"
    >
        {{ parsedContent }}
    </div>
</template>
<script>
export default {
    name: "Badge",
    props: {
        display: {
            type: String,
            default: 'primary',
            validator: (value) => ['primary', 'secondary', 'warning', 'success', 'danger', 'info'].includes(value)
        },
        content: {
            type: [String, Number],
            required: true,
        },
    },
    data() {
        return {
            classes: {
                'primary': 'bg-primary-20 text-primary',
                'secondary': 'bg-secondary-20 text-secondary',
                'warning': 'bg-semantic-warning-light text-semantic-warning-dark',
                'success': 'bg-semantic-success-light text-semantic-success-dark',
                'danger': 'bg-semantic-error-light text-semantic-error-dark',
                'info': 'bg-semantic-info-light text-semantic-info-dark',
            }
        }
    },
    computed: {
        parsedContent() {
            if (typeof this.content === 'number') {
                return this.content > 999 ? '999+' : this.content;
            }
            return this.content;
        },
        badgeClass() {
            return this.classes[this.display];
        }
    }
}
</script>

<style scoped>

</style>
